import React from "react";
import "./CustomSpinner.css";

const CustomSpinner =()=>  {
    return (
      <div className="loader">
        <div
          className="loader-background">
          <div className="custom-loader"></div>
        </div>
      </div>
    );
  }

export default CustomSpinner;
